import {createReducer} from '../utils';
import {
    LOGIN_USER_REQUEST,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILURE,
    LOGOUT_PREPARE,
    LOGOUT_USER,
    AUTH_CHECK,
    AUTH_SUCCESS,
    AUTH_FAILURE,
    AUTH_RE_CHECK,
    AUTH_NEEDS_RELOG
} from '../constants';

const initialState = {
    token: null,
    username: null,
    isAuthenticated: false,
    isAuthenticating: false,
    isLoggingOut: false,
    doAuth: true,
    needsRelog: false,
    statusText: null
};

export default createReducer(initialState, {
    [LOGIN_USER_REQUEST]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': true,
            'statusText': null
        });
    },
    [LOGIN_USER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': false,
            'isAuthenticated': true,
            'isLoggingOut': false,
            'doAuth': false,
            'needsRelog': false,
            'token': payload.token,
            'username': payload.username,
            'statusText': 'You have been successfully logged in.'
        });

    },
    [LOGIN_USER_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': false,
            'isAuthenticated': false,
            'isLoggingOut': false,
            'doAuth': false,
            'needsRelog': false,
            'token': null,
            'username': null,
            'statusText': `Authentication Error: ${payload.status} ${payload.statusText}`
        });
    },
    [LOGOUT_PREPARE]: (state, payload) => {
        return Object.assign({}, state, {
            'isLoggingOut': true,
            'doAuth': false,
            'needsRelog': false
        });
    },
    [LOGOUT_USER]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticated': false,
            'isLoggingOut': false,
            'token': null,
            'doAuth': false,
            'needsRelog': false,
            'username': null,
            'statusText': 'You have been successfully logged out.'
        });
    },
    [AUTH_RE_CHECK]: (state, payload) => {
        return Object.assign({}, state, {
            'doAuth': true,
            'needsRelog': false
        });

    },
    [AUTH_NEEDS_RELOG]: (state, payload) => {
        return Object.assign({}, state, {
            'needsRelog': true,
            'doAuth': false
        });

    },
    [AUTH_CHECK]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': true,
            'doAuth': false,
            'needsRelog': false
        });

    },
    [AUTH_CHECK]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': true,
            'doAuth': false,
            'needsRelog': false
        });

    },
    [AUTH_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': false,
            'isAuthenticated': true,
            'doAuth': false,
            'needsRelog': false
        });

    },
    [AUTH_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': false,
            'isAuthenticated': false,
            'doAuth': false,
            'needsRelog': false,
            'token': null,
            'username': null,
            'statusText': `Authentication Error: ${payload.status} ${payload.statusText}`
        });

    },
});




// WEBPACK FOOTER //
// ./src/reducers/auth.js